import { render } from "./ProductSlider.vue?vue&type=template&id=c0f34ac8"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"

import "./ProductSlider.vue?vue&type=style&index=0&id=c0f34ac8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__